/*
  Setnummers exact zoeken.

  Shopify zoekt getallen "ongeveer": wie 42115 intypt kreeg ook de Land Rover
  42110, de Charger 42111 en de Volvo 42114 te zien. Zet je het nummer tussen
  aanhalingstekens, dan matcht Shopify alleen nog exact en houd je de twee
  juiste houders over.

  Dit bestand doet twee dingen:
    - geckoZoekterm() vertaalt wat de bezoeker intypt naar wat Shopify wil
    - elk zoekformulier op de site krijgt die vertaling mee bij het versturen

  De suggesties tijdens het typen lopen langs dezelfde vertaling; dat gebeurt in
  predictive-search.js. Op de zoekpagina worden de aanhalingstekens weer uit de
  koptekst en het invoerveld gehaald, zodat de bezoeker ze nooit ziet
  (sections/main-search.liquid).

  Alleen een zoekterm die volledig uit cijfers bestaat wordt vastgezet. Typt
  iemand "lamborghini 42115", dan blijft dat ongemoeid: Shopify eist dan al dat
  beide woorden voorkomen en levert vanzelf het goede antwoord.
*/

window.geckoZoekterm = function (term) {
  const schoon = (term || '').trim();
  return /^\d{3,8}$/.test(schoon) ? '"' + schoon + '"' : schoon;
};

document.addEventListener(
  'submit',
  function (event) {
    const formulier = event.target;
    if (!formulier || formulier.getAttribute('role') !== 'search') return;

    const veld = formulier.querySelector('input[name="q"]');
    if (!veld) return;

    const zoekterm = window.geckoZoekterm(veld.value);
    if (zoekterm !== veld.value) veld.value = zoekterm;
  },
  true
);


/*
  De vraag in het balkje past niet op elke schermbreedte. Boven de 1360 pixels
  is er ruimte voor de hele zin; daaronder moet het menu van zeven items op één
  regel blijven en houden we het bij één woord. Zie assets/zoekbalk.css.
*/
document.addEventListener('DOMContentLoaded', function () {
  const veld = document.getElementById('Zoekbalk-Kop');
  if (!veld) return;

  const ruim = window.matchMedia('(min-width: 990px)');

  const zetTekst = function () {
    veld.placeholder = ruim.matches ? 'Voer setnummer in' : 'Setnummer';
  };

  zetTekst();
  ruim.addEventListener('change', zetTekst);
});
